export default {"src":"/_next/static/media/StaplerCircumcision2.f9110185.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};